/** @jsx isolateComponent */
import { useMemo, useState } from 'react';
import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Icon, Colors, ServiceIconShell, Typography, } from '@zapier/design-system';
import { ServiceIcon } from '@zapier/product-get-help/esm/components/shared/ServiceIcon';
import ExternalLink from '@zapier/product-get-help/esm/components/shared/ExternalLink';
import { groupIncidents } from './utils';
const headingCss = css `
  background-color: ${Colors.warning10};
  height: 58px;
  display: grid;
  grid-column-gap: 19px;
  grid-template-columns: min-content 1fr min-content;
  align-items: center;
  padding-left: 17px;
  padding-right: 30px;
  ${Typography.smallPrint1Semibold}
  color: ${Colors.neutral800};
`;
const toggleCss = css `
  white-space: nowrap;
  &:hover {
    color: ${Colors.blueJeans};
    text-decoration: underline;
  }
`;
const listCss = css `
  padding: 21px 55px 18px 13px;
  display: grid;
  grid-row-gap: 20px;
`;
const rowCss = css `
  padding-left: 13px;
  display: grid;
  grid-column-gap: 16px;
  grid-template-columns: min-content 1fr;
`;
const maybeIconCss = css `
  padding-top: 4px;
  width: 30px;
`;
const incidentInfoCss = css `
  display: grid;
  grid-row-gap: 5px;
`;
const incidentTitleCss = css `
  ${Typography.smallPrint1Semibold}
  color: ${Colors.neutral800};
`;
const incidentBodyCss = css `
  ${Typography.smallPrint1}
  color: ${Colors.neutral600};
`;
const linkCss = css `
  ${Typography.smallPrint1Semibold}
  text-decoration: underline;
  color: ${Colors.blueJeans};
  &:hover {
    color: ${Colors.night};
  }
`;
const Incident = ({ showIcon, iconApp, status, name, body, shortlink, }) => {
    return (isolateComponent("li", { css: rowCss },
        isolateComponent("div", { css: maybeIconCss }, showIcon &&
            (iconApp ? (isolateComponent(ServiceIcon, { serviceName: iconApp, size: 30 })) : (isolateComponent(ServiceIconShell, { size: 30 },
                isolateComponent(Icon, { color: "error300", name: "miscBoltOutlined", size: 24 }))))),
        isolateComponent("div", { css: incidentInfoCss },
            isolateComponent("p", { css: incidentTitleCss },
                status[0].toUpperCase(),
                status.substr(1),
                ": ",
                name),
            isolateComponent("p", { css: incidentBodyCss }, body),
            shortlink && (isolateComponent(ExternalLink, { css: linkCss, href: shortlink }, "View all updates")))));
};
/** Renders an expandable block with incidents. */
const Incidents = ({ title, incidents }) => {
    const [isOpen, setIsOpen] = useState(false);
    const groups = useMemo(() => groupIncidents(incidents), [incidents]);
    const toggleIsOpen = () => setIsOpen(!isOpen);
    return (isolateComponent("div", null,
        isolateComponent("div", { css: headingCss },
            isolateComponent(Icon, { color: "neutral700", name: "alertInfoFill", size: 24 }),
            isolateComponent("span", null, title),
            isolateComponent("button", { css: toggleCss, onClick: toggleIsOpen }, isOpen ? 'Hide' : 'Learn more')),
        isOpen && (isolateComponent("ol", { css: listCss }, groups.map((groupOfIncidents, g) => groupOfIncidents.map((incident, i) => (isolateComponent(Incident, Object.assign({ key: `${g}-${i}`, showIcon: i === 0 }, incident)))))))));
};
export default Incidents;
